import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, map, Observable, throwError} from "rxjs";
import {environment} from "../../environments/environment";
import {Impresoras} from "../models/Impresoras";

@Injectable({
  providedIn: 'root'
})
export class ImpresorasService {
  private impresorasUrl = environment.impresorasUrl;

  constructor(private http: HttpClient) {
  }

  getAllImpresoras(): Observable<Impresoras[]> {
    return this.http.get<Impresoras[]>(this.impresorasUrl).pipe(
      map(res => {
        return res.map(item => {
          return Impresoras.transformData(item);
        });
      }),
      catchError(err => {
        return throwError(err);
      }));
  }

  addOrUpdate(impresora: Impresoras, add: boolean): Observable<Impresoras> {
    if (add) {
      return this.addImpresoras(impresora);
    } else {
      return this.updateImpresoras(impresora);
    }
  }

  addImpresoras(impresora: Impresoras): Observable<any> {
    return this.http.post(this.impresorasUrl, impresora).pipe(
      catchError((err) => {
        console.log("Failed to add impresora code: " + impresora.impresoraCode);
        return throwError(err);
      })
    );
  }

  updateImpresoras(impresora: Impresoras): Observable<any> {
    return this.http.put(this.impresorasUrl, impresora).pipe(
      catchError((err) => {
        console.log("Failed to update for impresora code: " + impresora.impresoraCode);
        return throwError(err);
      }));
  }
}
